import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { GetCorePageDataService } from '../sitecore-data-mapper/get-core-page-data.service';

@Injectable()
export class BaseResolverService implements Resolve<any> {
  policyData: any;
  constructor(private getSiteCoreDataService: GetCorePageDataService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const pageName = route.data.state;
    return forkJoin({
      siteCore: this.getSiteCoreDataService.getSiteCoreData(pageName)
    });
  }
}
